// Rewrites root-relative hrefs (href="/products/x") so they keep the current
// market/locale prefix (e.g. "/en-gb/products/x") instead of silently
// resolving back to the default market. Covers links hardcoded in theme code,
// merchant-authored rich text/HTML settings, and third-party app markup -
// anything that doesn't go through Shopify's own locale-aware URL objects.
//
// Runs an initial sweep on load, then keeps watching via MutationObserver so
// links added later (cart drawer, predictive search, AJAX-rendered collection
// grids, etc.) get fixed too.
;(function () {
  var EXEMPT_PREFIXES = ['/a/', '/apps/', '/cdn/', '/checkout', '/cart']

  function getMarketRoot () {
    var root = (window.routes && window.routes.root_url) || '/'
    return root === '/' ? '' : root.replace(/\/+$/, '')
  }

  function isExempt (href) {
    for (var i = 0; i < EXEMPT_PREFIXES.length; i++) {
      if (href.indexOf(EXEMPT_PREFIXES[i]) === 0) return true
    }
    return false
  }

  function needsFix (href, marketRoot) {
    if (!href) return false
    if (href.charAt(0) !== '/') return false // external, mailto:, tel:, #anchor, etc.
    if (href.charAt(1) === '/') return false // protocol-relative (//cdn.example.com)
    if (href === marketRoot || href.indexOf(marketRoot + '/') === 0)
      return false // already correct
    if (isExempt(href)) return false

    return true
  }

  function fixLink (link, marketRoot) {
    var href = link.getAttribute('href')

    if (needsFix(href, marketRoot)) {
      link.setAttribute('href', marketRoot + href)
    }
  }

  function fixLinksWithin (root, marketRoot) {
    if (root.nodeType !== 1 && root !== document) return

    if (root.nodeType === 1 && root.matches && root.matches('a[href]')) {
      fixLink(root, marketRoot)
    }

    if (!root.querySelectorAll) return

    var links = root.querySelectorAll('a[href]')
    for (var i = 0; i < links.length; i++) {
      fixLink(links[i], marketRoot)
    }
  }

  function init () {
    var marketRoot = getMarketRoot()
    if (!marketRoot) return // default market - nothing to fix

    fixLinksWithin(document, marketRoot)

    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          fixLinksWithin(node, marketRoot)
        })
      })
    })

    observer.observe(document.body, { childList: true, subtree: true })
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init)
  } else {
    init()
  }
})()
